class CartProgressBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-progress'];
  }

  connectedCallback() {
    this.animateToProgress();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-progress' && oldValue !== newValue) {
      this.animateToProgress();
    }
  }

  get targetRatio() {
    const raw = this.getAttribute('data-progress') || '0';
    const num = Number(raw);
    if (!Number.isFinite(num)) return 0;
    const clamped = Math.max(0, Math.min(100, num));
    return clamped / 100;
  }

  animateToProgress() {
    const ratio = this.targetRatio;

    // Reset to 0 so we get a nice 0 → target animation
    this.style.setProperty('--cart-progress', '0');

    // Double rAF to ensure layout is committed before animating
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.style.setProperty('--cart-progress', String(ratio));
      });
    });
  }
}

if (!customElements.get('cart-progress-bar')) {
  customElements.define('cart-progress-bar', CartProgressBar);
}
